import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.support.'

@vsingleton()
export class AdminPredefinedAnswerRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'predefined-answers.'

  store() {
    return this.ziggyRoute('store')
  }

  update(id: number) {
    return this.ziggyRoute('update', id)
  }

  destroy(id: number) {
    return this.ziggyRoute('destroy', id)
  }

  search() {
    return this.ziggyRoute('search')
  }

}
